angular.module('bb.external').component('bbExternalFeedback', {
  bindings: {},
  controller: ExternalFeedbackController,
  controllerAs: 'vm',
  template: require('./external_feedback.html'),
});

ExternalFeedbackController.$inject = [
  'ExternalAuth',
  'ExternalService',
  'ErrorService',
  '$routeParams',
  '$route',
  '$location',
  '$scope',
];

function ExternalFeedbackController(
  ExternalAuth,
  ExternalService,
  ErrorService,
  $routeParams,
  $route,
  $location,
  $scope,
) {
  const vm = this;
  vm.auth = ExternalAuth.auth;
  vm.$onInit = function () {
    vm.loading = true;
    // Get feedback template elements
    vm.listing = vm.auth.listing;
    ExternalService.getFeedback(
      $routeParams.dashboardId,
      $routeParams.appointmentId,
    )
      .then(function ({ id, template }) {
        vm.id = id;
        vm.template = template;
      })
      .catch(function (err) {
        ErrorService.toastyHTTPErr(err);
      })
      .finally(function () {
        vm.loading = false;
      });
  };

  vm.onResponseChange = function (index, response) {
    vm.template[index] = { ...vm.template[index], response };
    setTimeout(() => $scope.$digest(), 0);
  };

  vm.submitFeedback = function () {
    vm.loading = true;
    const feedback = {
      id: vm.id,
      contactId: vm.auth.user.id,
      template: vm.template,
    };

    ExternalService.submitFeedback(
      feedback,
      $routeParams.appointmentId,
      $routeParams.dashboardId,
    )
      .then(function () {
        swal(
          {
            title: `Feedback Submitted!`,
            html: true,
            type: 'success',
          },
          function () {
            $location.path(`/dash/${vm.auth.dashboardId}/appointments`);
            $route.reload();
          },
        );
      })
      .catch(function (err) {
        vm.loading = false;
        ErrorService.toastyHTTPErr(err);
      });
  };
}

export {};
